import PeerAssessmentModal from './modal';

export default {
  props: ['coursework', 'extra_credit'],

  template: '', //Set dynamically on create

  data() {
    return {
      number: 0,
      name: this.extra_credit ? 'Extra Credit Peer Assessment' : 'Peer Assessment',
      task: this.extra_credit ? 'Do peer assessments for extra credit' : 'Do peer assessments',
      isInView: false,
      showPeerAssessmentModal: false,
      userState: {}
    };
  },

  components: {
    PeerAssessmentModal
  },

  computed: {
    isVisible() {
      return this.extra_credit ? this.coursework.has_extra_peer_grading : this.coursework.has_peer_grading;
    },

    isActive() {
      return this.isVisible;
    },

    isComplete() {
      return this.currentStatus === 'complete';
    },

    currentStatus() {
      if (this.peerEntries.length) {
        if (this.unsubmittedAssessmentCount) {
          if (this.unsubmittedAssessmentCount === this.peerEntries.length) {
            return 'unsubmitted';
          } else if (this.unsubmittedAssessmentCount !== this.peerEntries.length) {
            return 'in-progress';
          }
        } else {
          if (this.completedAssessmentCount !== this.peerEntries.length) {
            return 'review';
          } else if (this.completedAssessmentCount === this.peerEntries.length) {
            return 'complete';
          }
        }
      } else {
        return 'unavailable';
      }
    },

    submitBtnText() {
      if (this.currentStatus === 'unavailable' || this.currentStatus === 'unsubmitted')
        return 'Begin Peer Assessment';
      else if (this.currentStatus === 'in-progress')
        return 'Continue Peer Assessment';
      else if (this.currentStatus === 'review')
        return 'Submit Peer Assessment';
      else if (this.currentStatus === 'complete')
        return 'Edit Peer Assessment';
    },

    peerEntries() {
      return this.extra_credit ?
        this.coursework.extra_peer_entries :
        this.coursework.peer_entries;
    },

    completedAssessmentCount() {
      return _.filter(this.peerEntries, function(entry) { return entry.grade.id && _.includes(['complete','excluded'], entry.grade.status); }).length;
    },

    pendingAssessmentCount() {
      return _.filter(this.peerEntries, function(entry) { return entry.grade.id && entry.grade.status === 'pending'; }).length;
    },

    unsubmittedAssessmentCount() {
      return _.filter(this.peerEntries, function(entry) { return !entry.grade.id || entry.grade.status === 'initialized'; }).length;
    },

    lastPeerAssessmentDate() {
      return this.extra_credit ? this.coursework.last_extra_peer_assessment_date : this.coursework.last_peer_assessment_date;
    },

    completedRegularAssessments() {
      let completed = false;

      if(this.coursework.peer_entries.length)
        completed = _.all(this.coursework.peer_entries, function(entry) { return entry.grade.id && _.includes(['complete','excluded'], entry.grade.status); });

      return completed;
    }
  },

  methods: {
    getPeerEntries(extra_credit) {
      const self = this;

      let response = new Kadenze.AjaxRequest({
        type: 'GET',
        url: Kadenze.Routes.course_coursework_peer_entries_for_grading_path(
          this.coursework.course_id,
          this.coursework.id,
          { extra_credit }
        )
      });

      response.done(function (data, textStatus, xhr) {
        if (extra_credit)
          self.coursework.extra_peer_entries = data;
        else
          self.coursework.peer_entries = data;
      });
    }
  },

  created() {
    this.$options.template = this.extra_credit ?
      '#extra_peer_assessment_step_template' :
      '#peer_assessment_step_template';

    this.$parent.steps.push(this);

    if (!this.extra_credit)
      Kadenze.UserState.get(userState => this.userState = userState)
  }
};
